import { activityTimeframeConfig } from '../../../../utils/constants';

export const timeframeToAnalyticsValue = (apiValue) => activityTimeframeConfig[apiValue]?.analyticsValue;

// Power users default to the backend-recommended timeframe (e.g. 12 Month); free users
// fall through to the first unlocked timeframe in the response (All Time).
// The recommendation is validated against the timeframes the backend returned in this
// same response, not the static local config, so a timeframe added server-side before
// the client ships is still honored as long as it appears in the response.
export const resolveDefaultTimeFrame = (recommendedTimeFrame, timeframes) => {
    const hasTimeframes = Array.isArray(timeframes);
    if (recommendedTimeFrame && hasTimeframes && timeframes.some(t => t?.key === recommendedTimeFrame)) {
        return recommendedTimeFrame;
    }
    if (hasTimeframes) {
        const unlocked = timeframes.find(t => t?.locked === false);
        if (unlocked) { return unlocked.key; }
    }
    return null;
};

export const getFilteredStats = (allData, sportKey, filters, fallbackStatKeys) => {
    if (!allData?.sports?.[sportKey]) { return []; }

    const sportData = allData.sports[sportKey];
    const matchType = filters.matchType || 'Singles';
    const verified = filters.verified || false;
    const timeFrame = filters.timeFrame || 'allTime';

    // API shape: definitions = [{ key, label, order }, ...]
    const definitions = sportData.definitions || [];
    const fallbackMap = {};
    fallbackStatKeys.forEach(sk => { fallbackMap[sk.key] = sk; });

    const orderedKeys = Array.isArray(definitions) && definitions.length > 0
        ? [...definitions]
            .sort((a, b) => a.order - b.order)
            .map(def => ({
                key: def.key,
                title: def.label || def.key,
                mobileTitle: fallbackMap[def.key]?.mobileTitle || def.label || def.key,
                locked: !!def.locked,
            }))
        : fallbackStatKeys.map(sk => ({
            key: sk.key,
            title: sk.title,
            mobileTitle: sk.mobileTitle || sk.title,
            locked: false,
        }));

    if (orderedKeys.length === 0) { return []; }

    // API shape: sportData.results = [{ timeframe, matchType, verified, stats[] }, ...]
    const result = (sportData.results || []).find(r => r.timeframe === timeFrame &&
        r.matchType === matchType &&
        r.verified === verified);

    const rankLabel = allData.rankLabel ?? null;

    return orderedKeys.map(({ key, title, mobileTitle, locked }) => {
        const stat = result ? (result.stats || []).find(s => s.key === key) : null;
        return {
            statKey: key,
            title,
            mobileTitle,
            locked,
            total: stat?.played ?? 0,
            wins: stat?.won ?? 0,
            losses: stat?.lost ?? 0,
            rank: stat?.rank ?? null,
            rankDisplay: stat?.rankDisplay ?? null,
            rankLabel,
        };
    });
};

export const getMatchesPlayedStat = (allData, sportKey, filters, fallbackStatKeys) => {
    const stats = getFilteredStats(allData, sportKey, filters, fallbackStatKeys);
    return stats.find(s => s.statKey === 'matchesPlayed') || null;
};
